import { render, staticRenderFns } from "./DockerTags.vue?vue&type=template&id=2f86c802"
import script from "./DockerTags.vue?vue&type=script&lang=js"
export * from "./DockerTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports